import { toast } from 'react-toastify';
import { createCharge } from './services';
import { setCharges, setChargesErrors, clearChargesErrors, handleLoading } from './actions';
import { fetchClient } from '../../BasicInfo/store/services';

export const loadCharges = params => dispatch => {
  dispatch(handleLoading(true));

  return fetchClient(params)
    .then(({ data }) => {
      dispatch(setCharges(data));
      return data;
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const upsertCharge = params => dispatch => {
  dispatch(handleLoading(true));

  return createCharge(params)
    .then(() => {
      toast.success('Cobrança criada com sucesso.');
      return Promise.resolve();
    })
    .catch(error => {
      if(!error) {
        dispatch(clearChargesErrors());
        return Promise.reject();
      }

      dispatch(setChargesErrors(error));

      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}